module.exports = __webpack_public_path__ + "img/guide.0afcd190.png";